<template>
	<v-layout row justify-center>
		<v-dialog
			:fullscreen="fullscreen"
			v-model="showModal"
			lazy
			max-width="800px"
			:transition="utils.getSettings('animation')"
			@keydown.esc="showModal = false"
		>
			<v-card>
				<v-tabs v-model="active" color="blue darken-3" dark>
					<v-tab v-for="tab in tabs" :key="tab" :href="'#' + tab" ripple>{{
						tab
					}}</v-tab>
					<v-tabs-slider color="yellow"></v-tabs-slider>
					<v-tabs-items>
						<v-tab-item :key="'Gegevens'" :value="'Gegevens'">
							<v-card>
								<v-card-title class="pb-0">
									<h2>
										Beeindigde reservering #{{
											selectedReservation.reservationNumber
										}}
										({{ selectedReservation.name }})
									</h2>
								</v-card-title>
								<v-card-text>
									<v-container grid-list-md px-0 pt-0>
										<v-layout wrap>
											<v-flex md12 xs12>
												<v-select
													v-bind:items="units"
													v-model="selectedReservation.unitId"
													label="Selecteer auto"
													item-text="fullDescription"
													item-value="unitId"
													single-line
													menu-props="bottom"
												></v-select>
											</v-flex>
											<v-flex xs7 sm5>
												<v-menu
													ref="menu"
													:close-on-content-click="false"
													v-model="menu"
													transition="scale-transition"
													offset-y
													full-width
													:nudge-right="40"
													max-width="330px"
													min-width="330px"
													:return-value.sync="selectedReservation.startDate"
												>
													<v-text-field
														slot="activator"
														label="Startdatum"
														v-model="fullStartDate"
														prepend-icon="event"
														@change="setReservationChanged()"
														readonly
													></v-text-field>
													<v-date-picker
														v-model="selectedReservation.startDate"
														no-title
														scrollable
													>
														<v-spacer></v-spacer>
														<v-btn flat color="primary" @click="menu = false"
															>Annuleren</v-btn
														>
														<v-btn
															flat
															color="primary"
															@click="
																$refs.menu.save(selectedReservation.startDate)
															"
															>Bevestigen</v-btn
														>
													</v-date-picker>
												</v-menu>
											</v-flex>
											<v-flex xs5 sm6 md4>
												<v-text-field
													label="Tijd"
													v-model="selectedReservation.startTime"
													@change="setReservationChanged()"
													type="time"
												></v-text-field>
											</v-flex>
											<v-flex xs7 sm5>
												<v-menu
													ref="menu2"
													:close-on-content-click="false"
													v-model="menu2"
													transition="scale-transition"
													offset-y
													full-width
													:nudge-right="40"
													max-width="330px"
													min-width="330px"
													:return-value.sync="selectedReservation.endDate"
												>
													<v-text-field
														slot="activator"
														label="Einddatum"
														v-model="fullEndDate"
														@change="setReservationChanged()"
														prepend-icon="event"
														readonly
													></v-text-field>
													<v-date-picker
														v-model="selectedReservation.endDate"
														no-title
														scrollable
													>
														<v-spacer></v-spacer>
														<v-btn flat color="primary" @click="menu2 = false"
															>Annuleren</v-btn
														>
														<v-btn
															flat
															color="primary"
															@click="
																$refs.menu2.save(selectedReservation.endDate)
															"
															>Bevestigen</v-btn
														>
													</v-date-picker>
												</v-menu>
											</v-flex>
											<v-flex xs5 sm6 md4>
												<v-text-field
													label="Tijd"
													v-model="selectedReservation.endTime"
													@change="setReservationChanged()"
													type="time"
												></v-text-field>
											</v-flex>
											<v-flex
												xs12
												v-if="!selectedReservation.setCustomDistance"
											>
												<v-checkbox
													label="Afstand opnieuw berekenen?"
													v-if="dateChanged"
													v-model="selectedReservation.dateChanged"
												></v-checkbox>
											</v-flex>
											<v-flex xs8>
												<v-text-field
													label="Gebruiker"
													v-model="selectedReservation.username"
													readonly
												></v-text-field>
											</v-flex>
											<v-flex xs4>
												<v-btn color="primary" flat @click="editUser = true"
													>Wijzig</v-btn
												>
											</v-flex>
											<v-flex v-if="editUser" xs12>
												<v-autocomplete
													@keyup="searchUser"
													label="Zoek gebruiker"
													autocomplete="false"
													:loading="loading"
													item-text="Name"
													item-value="user_id"
													chips
													:items="items"
													:search-input.sync="search"
													v-model="select"
												></v-autocomplete>
											</v-flex>
											<v-flex xs12>
												<v-text-field
													label="Telefoonummer"
													type="text"
													v-model="selectedReservation.phoneno"
													readonly
												></v-text-field>
											</v-flex>
											<v-flex xs12>
												<v-select
													:items="paidOptions"
													v-model="selectedReservation.paid"
													label="Select"
													single-line
													menu-props="bottom"
													@change="
														selectedReservation.amountPaid =
															selectedReservation.totalCosts
													"
												></v-select>
											</v-flex>
											<v-flex xs4>
												<v-text-field
													label="Totaalbedrag"
													v-model="selectedReservation.totalCosts"
													type="number"
													readonly
												></v-text-field>
											</v-flex>
											<v-flex xs4>
												<v-text-field
													label="Betaald"
													v-model="selectedReservation.amountPaid"
													type="number"
													min="0"
													step="1"
												></v-text-field>
											</v-flex>
											<v-flex xs4>
												<v-text-field
													label="Openstaand"
													v-model="amountOpen"
													type="number"
													readonly
												></v-text-field>
											</v-flex>
											<v-flex xs12>{{ selectedReservation.remark }}</v-flex>
										</v-layout>
									</v-container>
									<small>* verplichte velden</small>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item :key="'Klantgegevens'" :value="'Klantgegevens'">
							<v-container grid-list-md pa-2>
								<customer-card :user="selectedReservation"></customer-card>
								<temp-customer
									@setUseTempForInvoice="
										selectedReservation.useTempForInvoice = $event
									"
									:optional="true"
									:user="selectedReservation.tempCustomer"
									:useTempForInvoice="selectedReservation.useTempForInvoice"
									:showInvoiceOption="true"
								></temp-customer>
							</v-container>
						</v-tab-item>

						<v-tab-item :key="'Kostenoverzicht'" :value="'Kostenoverzicht'">
							<v-card>
								<v-card-title>
									<h2>Kostenoverzicht</h2>
								</v-card-title>
								<v-card-text>
									<v-container grid-list-md pa-1>
										<v-layout wrap>
											<reservation-cost-details
												:reservation="selectedReservation"
												:editable="true"
											/>
											<v-flex xs12>
												<v-btn
													color="darken-1"
													flat
													@click.native="
														$refs.viewInvoice.showDialog(
															selectedReservation,
															'view',
															false
														)
													"
												>
													<v-icon>picture_as_pdf</v-icon>Toon factuur
												</v-btn>
											</v-flex>
										</v-layout>
									</v-container>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item :key="'Facturatie'" :value="'Facturatie'">
							<v-card>
								<v-card-title>
									<h2>Facturatie</h2>
								</v-card-title>
								<v-card-text>
									<v-container grid-list-md pa-1>
										<v-layout wrap v-if="sendingMail">
											<v-progress-circular
												indeterminate
												color="primary"
											></v-progress-circular>
										</v-layout>
										<v-layout wrap v-if="!sendingMail">
											<v-form ref="reminderForm">
												<p v-if="selectedReservation.paid !== '0'">
													Let op factuur is al betaald!
												</p>
												<br />
												<v-layout wrap>
													<v-flex md8>
														<v-text-field
															label="Onderwerp"
															v-model="subject"
															required
														></v-text-field>
													</v-flex>
													<v-flex md4>
														<v-btn @click="saveTemplate()"
															>Template opslaan</v-btn
														>
													</v-flex>
													<v-flex md8>
														<v-select
															v-model="selectedTemplate"
															:items="mailTemplates"
															label="Opgeslagen templates"
															item-text="subject"
															item-value="id"
															required
														></v-select>
													</v-flex>
													<v-flex md4>
														<v-btn
															color="red darken-1"
															flat
															@click="deleteTemplate()"
															v-if="selectedTemplate"
															>Template verwijderen</v-btn
														>
													</v-flex>
												</v-layout>
												<v-flex md12>
													<v-text-field
														label="E-mailadres"
														v-model="emailaddress"
														:rules="emailRules"
														required
													></v-text-field>
												</v-flex>
												<wysiwyg v-model="mailText" />
												<v-checkbox
													label="Factuur meesturen?"
													v-model="sendInvoice"
												></v-checkbox>
												<v-btn color="green" dark @click="sendReminder()"
													>Verzenden</v-btn
												>
												<v-flex md12>
													<v-expansion-panel>
														<v-expansion-panel-content
															v-for="(item, i) in sentReminders"
															:key="i"
														>
															<div slot="header">
																<v-icon>mail_outline</v-icon>
																{{ item.sentDateTime }} | {{ item.subject }}
															</div>
															<v-card>
																<v-card-text
																	v-html="item.content"
																></v-card-text>
															</v-card>
														</v-expansion-panel-content>
													</v-expansion-panel>
												</v-flex>
											</v-form>
										</v-layout>
									</v-container>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-tab-item :key="'Opties'" :value="'Opties'">
							<v-card>
								<v-card-title>
									<h2>Opties</h2>
								</v-card-title>
								<v-card-text>
									<v-container grid-list-md pa-1>
										<v-layout wrap>
											<v-btn
												color="red darken-1"
												dark
												class="ml-0"
												@click.native="confirm['delete'] = true"
												>Verwijderen</v-btn
											>
										</v-layout>
										<v-layout wrap mt-3 ml-2>
											<v-textarea
												name="remark"
												label="Opmerkingen"
												value
												v-model="selectedReservation.remark"
											></v-textarea>
											<v-btn @click="showAgreement()"
												>Download overeenkomst</v-btn
											>
											<v-btn @click="copyReservation()"
												>Kopieer naar nieuwe reservering</v-btn
											>
										</v-layout>
									</v-container>
								</v-card-text>
							</v-card>
						</v-tab-item>

						<v-layout row wrap>
							<v-flex xs8>
								<v-btn color="darken-1" flat @click.native="closeModal()"
									>Sluiten</v-btn
								>
							</v-flex>
							<v-flex xs4 text-xs-right>
								<v-btn
									color="primary darken-1"
									@click.native="updateReservation()"
									>Opslaan</v-btn
								>
							</v-flex>
						</v-layout>
					</v-tabs-items>
				</v-tabs>
			</v-card>
		</v-dialog>
		<v-dialog v-model="confirm['delete'] || confirm['end']" max-width="290">
			<v-card>
				<v-card-title class="headline">Weet u het zeker?</v-card-title>
				<v-card-text v-if="confirm['delete']"
					>Klik op bevestigen om te verwijderen.</v-card-text
				>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="gray darken-1"
						flat="flat"
						@click.native="confirm['delete'] = false"
						>Annuleren</v-btn
					>
					<v-btn color="primary" @click.native="deleteReservation()"
						>Bevestigen</v-btn
					>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<view-invoice ref="viewInvoice" :customDate="false"></view-invoice>
	</v-layout>
</template>
<script>
import * as utils from '@/utils/utils';
import moment from 'moment';
import { _ } from 'vue-underscore';
import ReservationCostDetails from '@/components/Reservations/ReservationCostDetails';
import CustomerCard from '@/components/subcomponents/CustomerCard';
import TempCustomer from '@/components/subcomponents/TempCustomer';
import ViewInvoice from '@/components/Reservations/ViewInvoice';
export default {
	name: 'HistoryModal',
	components: {
		ReservationCostDetails,
		CustomerCard,
		TempCustomer,
		ViewInvoice
	},
	mounted: function() {
		var self = this;
		window.emitter.$on('showHistory', function(data) {
			self.getHistoryData(data.id, data.showMail);
		});
	},
	created: function() {
		if (window.innerHeight < 750 && window.innerWidth < 750) {
			this.fullscreen = true;
		}
	},
	data() {
		return {
			tabs: [
				'Gegevens',
				'Klantgegevens',
				'Kostenoverzicht',
				'Facturatie',
				'Opties'
			],
			active: 'Gegevens',
			paidOptions: utils.getPaidOptions(),
			menu: false,
			menu2: false,
			dialog: false,
			loading: false,
			editUser: false,
			confirm: {
				delete: false
			},
			costData: {
				hours: 1,
				days: 1,
				weeks: 1
			},
			selectedReservation: {
				costData: {
					additionalItems: []
				},
				tempCustomer: {}
			},
			search: null,
			searchUsers: [],
			editUser: false,
			select: [],
			items: [],
			mailText: '',
			sendingMail: false,
			sendInvoice: true,
			subject: 'Openstaande factuur',
			sentReminders: [],
			utils: utils,
			showModal: false,
			fullscreen: false,
			emailaddress: '',
			mailTemplates: [],
			selectedTemplate: '',
			emailRules: [
				v => !!v || 'Gebruikersnaam is verplicht',
				v => this.utils.checkEmailAddress(v) || 'Ongeldig email-adres'
			],
			dateChanged: false
		};
	},
	props: ['user', 'edit', 'id', 'units'],
	computed: {
		amountOpen() {
			return (this.selectedReservation.totalCosts - this.selectedReservation.amountPaid).toFixed(2);
		},
		selectUnits() {
			return [];
		},
		fullStartDate() {
			return this.utils.getFullDate(this.selectedReservation.startDate);
		},
		fullEndDate() {
			return this.utils.getFullDate(this.selectedReservation.endDate);
		},
		mailDefaultText: {
			get: function() {
				return `Geachte [firstname] [lastname],
          <br/><br/>
          Uit onze administratie is gebleken dat u nog een factuur heeft openstaan. Wellicht is het aan uw aandacht ontschoten. Wij verzoeken u vriendelijk om deze aan ons te voldoen. <br/>
          Als u deze net heeft betaald dan kunt u dit bericht als niet verzonden beschouwen.</br>
          Bedankt voor uw medewerking!
          <br/><br/>
          [Dit bericht is een automatisch verzonden bericht]`;
			}
		}
	},
	watch: {
		search(val) {
			val && this.querySelections(val);
		},
		select(newVal) {
			var selectedUser = _.findWhere(this.items, { user_id: newVal });
			this.selectedReservation.user_id = selectedUser.user_id;
			this.selectedReservation.username = selectedUser.username;
			this.selectedReservation.phoneno = selectedUser.phoneno;
			this.selectedReservation.city = selectedUser.city;
		},
		active(newVal) {
			if (
				newVal === 'Facturatie' &&
				this.selectedReservation.user_id &&
				!self.sentReminders
			) {
				this.getSentReminders();
				this.getMailTemplates();
			}
		},
		selectedTemplate(templateId) {
			const selectedTemplate = _.findWhere(this.mailTemplates, {
				id: templateId
			});
			if (templateId) {
				let mailText = selectedTemplate.text;
				this.mailText = mailText;
			} else {
				this.mailText = this.mailDefaultText;
			}
		}
	},
	methods: {
		getHistoryData(id, showMail) {
			var self = this;
			this.showModal = true;
			this.dateChanged = false;
			utils
				.getData(basePath + 'api/reservations/historyDetails/' + id)
				.then(function(json) {
					self.selectedReservation = json.data;
					self.emailaddress = self.selectedReservation.username;
					self.selectedReservation.costData = {};
					self.selectedReservation.startTime = moment(
						self.selectedReservation.startDate
					).format('HH:mm');
					self.selectedReservation.startDate = moment(
						self.selectedReservation.startDate
					).format('YYYY-MM-DD');
					self.selectedReservation.endTime = moment(
						self.selectedReservation.endDate
					).format('HH:mm');
					self.selectedReservation.endDate = moment(
						self.selectedReservation.endDate
					).format('YYYY-MM-DD');
					self.selectedReservation.costData = JSON.parse(
						self.selectedReservation.totalCostsData
					);
					self.selectedReservation.totalWithoutDiscount =
						self.selectedReservation.costData.totalDecimal +
						parseFloat(self.selectedReservation.discount);
					self.selectedReservation.totalWithoutMileageCost =
						self.selectedReservation.totalWithoutDiscount -
						parseFloat(self.selectedReservation.costData.mileageCost);
					self.mailText = self.mailDefaultText;
					self.selectedReservation.id = self.selectedReservation.rentId;
					if (!self.selectedReservation.tempCustomer) {
						self.selectedReservation.tempCustomer = {};
					}
					if (showMail) {
						self.getSentReminders();
						self.active = 'Facturatie';
					}
				});
		},
		closeModal() {
			this.showModal = false;
		},
		querySelections(v) {
			var self = this;
			this.userLoading = true;
			var data = {
				query: v
			};
			utils
				.setData(basePath + 'api/users/searchUsers/', data)
				.then(function(response) {
					if (response && response.data) {
						self.items = response.data;
						self.searchUsersData = response.data;
					}
					self.userLoading = false;
				});
		},
		updateReservation() {
			var self = this;

			var data = {
				startDate: moment(
					self.selectedReservation.startDate +
						':' +
						self.selectedReservation.startTime,
					'YYYY-MM-DD HH:mm'
				).format(),
				endDate: moment(
					self.selectedReservation.endDate +
						':' +
						self.selectedReservation.endTime,
					'YYYY-MM-DD HH:mm'
				).format(),
				paid: self.selectedReservation.paid,
				discount: self.selectedReservation.discount,
				id: self.selectedReservation.rentId,
				rentId: self.selectedReservation.rentId,
				kmPrice: self.selectedReservation.kmPrice,
				mileage: self.selectedReservation.mileage,
				unitId: self.selectedReservation.unitId,
				prices: self.selectedReservation.costData.prices,
				user_id: self.selectedReservation.user_id,
				freeMileage: self.selectedReservation.freeMileage,
				mileage: self.selectedReservation.costData.mileage,
				remark: self.selectedReservation.remark,
				dateChanged: self.dateChanged,
				additionalItems: self.selectedReservation.costData.additionalItems,
				useTempForInvoice: self.selectedReservation.useTempForInvoice,
				setCustomDistance: self.selectedReservation.setCustomDistance,
				amountPaid: self.selectedReservation.amountPaid,
				tempCustomer: self.selectedReservation.tempCustomer,
				tempCustomerId: self.selectedReservation.tempCustomerId,
				useTempCustomer: self.selectedReservation.tempCustomer.useTempCustomer
					? self.selectedReservation.tempCustomer.useTempCustomer
					: false
			};

			utils
				.setData(basePath + 'api/reservations/updateHistoryDetails/', data)
				.then(function(json) {
					window.emitter.$emit('showToastMessage', {
						msg: 'Beëindigde reserving opgeslagen'
					});
					self.getHistoryData(self.selectedReservation.rentId, false);
					self.updateModel();
				});
		},
		searchUser(e) {
			// if (e.code == 'Backspace') {
			//   if (this.select) {
			//     this.select = null;
			//     this.search = '';
			//   }
			// }
		},
		showInvoice() {
			var self = this;
			utils
				.getData(
					basePath +
						'api/reservations/getInvoice/' +
						this.selectedReservation.rentId
				)
				.then(function(json) {
					window.location.href =
						basePath +
						'api/downloader/downloadInvoice/' +
						json.data +
						'/' +
						self.selectedReservation.rentId;
				});
		},
		updateModel() {
			window.emitter.$emit('updateHistory');
			this.$emit('update');
		},
		deleteReservation() {
			var self = this;
			utils
				.getData(
					basePath +
						'api/reservations/deleteHistory/' +
						this.selectedReservation.rentId
				)
				.then(function(json) {
					self.updateModel();
				});
			this.showModal = false;
			this.confirm.delete = false;
		},
		formatMailText() {
			let mailText = this.mailText;
			mailText = mailText.replace(
				'[firstname]',
				this.selectedReservation.firstname
			);
			mailText = mailText.replace(
				'[lastname]',
				this.selectedReservation.lastname
			);
			mailText = mailText.replace(
				'[linka2u]',
				`<a href="https://www.auto2use.nl/account/pay/${
					this.selectedReservation.rentId
				}">Klik op deze link om te kunnen betalen (iDeal)</a>`
			);
			return mailText;
		},
		sendReminder() {
			var self = this;

			if (this.$refs.reminderForm.validate()) {
				let data = {
					body: this.formatMailText(),
					subject: this.subject,
					emailaddress: this.emailaddress,
					historyId: this.selectedReservation.rentId,
					sendInvoice: this.sendInvoice
				};

				this.sendingMail = true;
				utils
					.setData(basePath + 'api/reservations/sendReminder', data)
					.then(function(json) {
						self.sendingMail = false;
						self.getSentReminders();
						window.emitter.$emit('showToastMessage', {
							msg: 'E-mail verzonden'
						});
					});
			}
		},
		getSentReminders() {
			var self = this;
			utils
				.getData(
					basePath +
						'api/reservations/getSentReminders/' +
						this.selectedReservation.rentId
				)
				.then(function(json) {
					self.sentReminders = json.data;
				});
		},
		setReservationChanged() {
			this.dateChanged = true;
		},
		showAgreement() {
			var self = this;
			utils
				.getData(
					basePath +
						'api/users/getAgreement/' +
						this.selectedReservation.user_id +
						'/' +
						this.selectedReservation.rentId
				)
				.then(function(json) {
					window.location.href =
						basePath +
						'api/downloader/downloadAgreement/' +
						json.data +
						'/' +
						self.selectedReservation.rentId;
				});
		},
		copyReservation() {
			this.$emit('copyReservation', this.selectedReservation);
			this.showModal = false;
		},
		getMailTemplates() {
			var self = this;
			utils
				.getData(basePath + 'api/dealers/getMailTemplates/history')
				.then(function(response) {
					if (response && response.data) {
						self.mailTemplates = response.data;
					} else {
						self.mailTemplates = [];
					}
					self.mailTemplates.unshift({
						subject: '',
						text: ''
					});
				});
		},
		saveTemplate() {
			const templateData = {
				subject: this.subject,
				text: this.mailText,
				type: 'history'
			};

			var self = this;
			utils
				.setData(basePath + 'api/dealers/createMailTemplate/', templateData)
				.then(function(response) {});
		},
		deleteTemplate() {
			var self = this;
			utils
				.getData(
					basePath + 'api/dealers/deleteMailTemplate/' + this.selectedTemplate
				)
				.then(response => {
					this.selectedTemplate = '';
					this.getMailTemplates();
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/History/HistoryModal.vue